import { NgModule } from '@angular/core';
import { DialogModule } from '@app/modules/ui/dialog/dialog.module';
import { ModalLoaderComponent } from '@app/modules/ui/modals/modal-loader/modal-loader.component';
import { SharedModule } from '@app/shared/shared.module';

import { ConfirmationModalComponent } from './confirmation-modal.component';
import { InformationModalComponent } from './information-modal.component';
import { ModalsService } from './modals.service';

@NgModule({
  imports: [DialogModule, SharedModule],
  declarations: [ConfirmationModalComponent, InformationModalComponent, ModalLoaderComponent],
  exports: [ModalLoaderComponent],
  providers: [ModalsService]
})
export class ModalsModule {}
